import { promisedRequest } from './helpers.js'

const PUSH_SUBSCRIPTION_URL = '/api/v1/push/subscription/'

// the browser's push subscription and the kinds of notification to send
export const sendPushSubscription = ({ subscription, alerts, credentials }) =>
  promisedRequest({
    url: PUSH_SUBSCRIPTION_URL,
    method: 'POST',
    credentials,
    payload: { subscription, data: { alerts } },
  }).then(({ data }) => {
    if (!data?.id) throw new Error('Bad response from server.')
    return data
  })

export const deletePushSubscription = ({ credentials }) =>
  promisedRequest({
    url: PUSH_SUBSCRIPTION_URL,
    method: 'DELETE',
    credentials,
  })
